import { buildProps, definePropType } from '@ll-plus/utils'

// import type { ExtractPropTypes } from 'vue'

export interface IParamsData {
  [key: string]: any
}

export interface IParamsColumn {
  dataIndex: string
  key: string
  title?: string
  [key: string]: any
}

export interface IParamsOption {
  label: string
  value: string
}

export const paramsOptions = [
  {
    label: 'string',
    value: 'string'
  },
  {
    label: 'integer',
    value: 'integer'
  },
  {
    label: 'boolean',
    value: 'boolean'
  },
  {
    label: 'number',
    value: 'number'
  },
  {
    label: 'array',
    value: 'array'
  }
]

export const contentTypeOptions: IParamsOption[] = [
  { label: 'text/html', value: 'text/html' },
  { label: 'text/plain', value: 'text/plain' },
  { label: 'text/xml', value: 'text/xml' },
  { label: 'image/gif', value: 'image/gif' },
  { label: 'image/jpeg', value: 'image/jpeg' },
  { label: 'image/png', value: 'image/png' },
  { label: 'application/xhtml+xml', value: 'application/xhtml+xml' },
  { label: 'application/xml', value: 'application/xml' },
  { label: 'application/atom+xml', value: 'application/atom+xml' },
  { label: 'application/json', value: 'application/json' },
  { label: 'application/pdf', value: 'application/pdf' },
  { label: 'application/msword', value: 'application/msword' },
  { label: 'application/octet-stream', value: 'application/octet-stream' },
  {
    label: 'application/x-www-form-urlencoded',
    value: 'application/x-www-form-urlencoded'
  },
  { label: 'multipart/form-data', value: 'multipart/form-data' }
]

export const paramsTableProps = buildProps({
  dataSource: {
    type: definePropType<IParamsData[]>(Array),
    default: () => []
  },
  columns: {
    type: definePropType<IParamsColumn[]>(Array),
    default: () => []
  },
  options: {
    type: definePropType<IParamsOption[]>(Array),
    default: () => []
  }
} as const)

export const paramsTableRowProps = buildProps({
  columns: {
    type: definePropType<IParamsColumn[]>(Array),
    default: () => []
  },
  dataSource: {
    type: definePropType<IParamsData[]>(Array),
    default: () => []
  },
  data: {
    type: definePropType<IParamsData>(Object),
    default: () => ({})
  },
  options: {
    type: definePropType<IParamsOption[]>(Array),
    default: () => []
  }
} as const)

export const paramsTableEmits = {
  add: (value: string) => !!value
}
// export const paramsTableRowEmits = {
//   add: () => true
// }
